import Vue from "vue";
import Router from "vue-router";
import AddCustomer from "@/components/AddCustomer";
import ListDemo from "@/components/ListDemo";
import DemoItem from "@/components/DemoItem";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/all",
      name: "all",
      component: ListDemo,
    },
    {
      path: "/",
      name: "all",
      redirect: "/all",
    },
    {
      path: "/video",
      name: "Video",
      component: ListDemo,
    },
    {
      path: "/rm",
      name: "RM",
      component: ListDemo,
    },
    // {
    //   path: "/editor",
    //   name: "Editor",
    //   component: ListDemo,
    // },
    // {
    //   path: "/live",
    //   name: "live",
    //   component: ListDemo,
    // },
    // {
    //   path: "/loop",
    //   name: "loop",
    //   component: DemoItem,
    //   props: { type: "LOOP_OPTIONS", componentName: "loop", title: "Loop" },
    // },
    // {
    //   path: "/chromless",
    //   name: "chromless",
    //   component: DemoItem,
    //   props: {
    //     type: "CHROMLESS_OPTIONS",
    //     componentName: "chromless",
    //     title: "chromless",
    //   },
    // },
    // {
    //   path: "/playback_rates",
    //   name: "playback_rates",
    //   component: DemoItem,
    //   props: {
    //     type: "PLAYBACKRATES_OPTIONS",
    //     componentName: "playBackRates",
    //     title: "chromless",
    //   },
    // },
    // {
    //   path: "/background",
    //   name: "background",
    //   component: DemoItem,
    //   props: {
    //     type: "BACKGROUND_OPTIONS",
    //     componentName: "background",
    //     title: "background",
    //   },
    // },
    // {
    //   path: "/download",
    //   name: "download",
    //   component: DemoItem,
    //   props: {
    //     type: "DOWNLOAD_OPTIONS",
    //     componentName: "download",
    //     title: "download",
    //   },
    // },
    {
      path: "/simple",
      name: "simple",
      component: DemoItem,
      props: {
        type: "CAPTION_OPTIONS",
        componentName: "caption",
        title: "Sous-titres",
      },
    },
    // {
    //   path: "/info",
    //   name: "info",
    //   component: DemoItem,
    //   props: {
    //     type: "INFO_OPTIONS",
    //     componentName: "info",
    //     title: "Information",
    //     plugin: "navigation",
    //   },
    // },
    // {
    //   path: "/partage",
    //   name: "partage",
    //   component: DemoItem,
    //   props: {
    //     type: "SHARE_OPTIONS",
    //     componentName: "share",
    //     title: "Partage",
    //     plugin: "navigation",
    //   },
    // },
    // {
    //   path: "/export",
    //   name: "export",
    //   component: DemoItem,
    //   props: {
    //     type: "EXPORT_OPTIONS",
    //     componentName: "export",
    //     title: "Export",
    //     plugin: "navigation",
    //   },
    // },
    // {
    //   path: "/relatedVideo",
    //   name: "relatedVideo",
    //   component: DemoItem,
    //   props: {
    //     type: "EXPORT_OPTIONS",
    //     componentName: "export",
    //     title: "Export",
    //   },
    // },
    // {
    //   path: "/TV",
    //   name: "TV",
    //   component: DemoItem,
    //   props: { type: "TV_OPTIONS", componentName: "export", title: "Export" },
    // },
    // {
    //   path: "/comments",
    //   name: "comments",
    //   component: DemoItem,
    //   props: {
    //     type: "COMMENTS_OPTIONS",
    //     componentName: "comments",
    //     title: "Commentaire",
    //     plugin: "navigation",
    //   },
    // },
    // {
    //   path: "/search",
    //   name: "search",
    //   component: DemoItem,
    //   props: {
    //     type: "SEARCH_OPTIONS",
    //     componentName: "search",
    //     title: "Recherche",
    //     plugin: "navigation",
    //   },
    // },
    // {
    //   path: "/mail",
    //   name: "mail",
    //   component: DemoItem,
    //   props: {
    //     type: "MAIL_OPTIONS",
    //     componentName: "mail",
    //     title: "Recherche",
    //     plugin: "navigation",
    //   },
    // },
    // {
    //   path: "/hotkey",
    //   name: "hotkey",
    //   component: DemoItem,
    //   props: {
    //     type: "HOTKEY_OPTIONS",
    //     componentName: "hotkey",
    //     title: "Recherche",
    //   },
    // },
    // {
    //   path: "/questionAndQuiz",
    //   name: "questionAndQuiz",
    //   component: DemoItem,
    //   props: {
    //     type: "QUESTION_AND_QUIZ_OPTIONS",
    //     componentName: "comments",
    //     title: "Commentaire",
    //     plugin: "navigation",
    //   },
    // },
    {
      path: "/navigation",
      name: "navigation",
      component: DemoItem,
      props: {
        type: "NAVIGATION_OPTIONS",
        componentName: "comments",
        title: "Navigation",
      },
    },
    {
      path: "/interactivity",
      name: "interactivity",
      component: DemoItem,
      props: {
        type: "INTERACTIVITY_OPTIONS",
        componentName: "comments",
        title: "Interactivity",
      },
    },
    // {
    //   path: "/setting",
    //   name: "setting",
    //   component: DemoItem,
    //   props: {
    //     type: "SETTING_OPTIONS",
    //     componentName: "setting",
    //     title: "Paramétre",
    //   },
    // },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js